var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-tab"},[_c('div',{staticClass:"list"},_vm._l((_vm.QuickList),function(item,index){return _c('div',{key:index,staticClass:"list-one",on:{"click":function($event){return _vm.linkTo(item)}}},[_c('img',{staticClass:"iconImg",attrs:{"src":item.Icon}}),_c('span',[_vm._v(_vm._s(item.Name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }